
        import i18n from 'i18n';
        import flattenObject from 'util/flattenObject';
    
            import ns0c2038ac29460deaff338cc7f0a9dd99en from './en.yaml'
            i18n.addResourceBundle('en', '0c2038ac29460deaff338cc7f0a9dd99', flattenObject(ns0c2038ac29460deaff338cc7f0a9dd99en), true, true);
        
        export default '0c2038ac29460deaff338cc7f0a9dd99';
    